export default {
  'addOA.title': 'เพิ่มบัญชี LINE OA',
  'addOA.button.text': 'เพิ่มเพื่อนเพื่อรับคูปอง!',
  'addOA.content.text':
    'เมื่อเพิ่มบัญชี LINE OA เป็นเพื่อนแล้ว คุณจะได้รับคูปองสำหรับใช้งาน พร้อมอัปเดตข่าวสาร สิทธิประโยชน์ และโปรโมชั่นพิเศษก่อนใคร',
} as Record<string, string>;
